var map = {
	"./AMERON_Davos.jpg": [
		117,
		0
	],
	"./Alpina_Gstaad.jpg": [
		118,
		1
	],
	"./Badrutt_St_Moritz.jpg": [
		119,
		12
	],
	"./Belvedere_Scuol.jpg": [
		120,
		23
	],
	"./Bernerhof_Kandersteg.jpg": [
		121,
		24
	],
	"./Carlton_St_Moritz.jpg": [
		122,
		25
	],
	"./Chedi_Andermatt.jpg": [
		123,
		26
	],
	"./Chesa_Randolina_Sils.jpg": [
		124,
		27
	],
	"./Grand_Bellevue_Gstaad.jpg": [
		125,
		28
	],
	"./Kernen_Schoenried_Gstaad.jpg": [
		126,
		29
	],
	"./Krone_La_Punt.jpg": [
		127,
		2
	],
	"./Kulm_St_Moritz.jpg": [
		128,
		3
	],
	"./Palace_Gstaad.jpg": [
		129,
		4
	],
	"./Radisson_Andermatt.jpg": [
		130,
		5
	],
	"./Riffelalp_Zermatt.jpg": [
		131,
		6
	],
	"./Rockresort_Laax.jpg": [
		132,
		7
	],
	"./Schoenegg_Wengen.jpg": [
		133,
		8
	],
	"./Schweizerhof_Lenzerheide.jpg": [
		134,
		9
	],
	"./Spitzhorn_Saanen.jpg": [
		135,
		10
	],
	"./Sporthotel_Pontresina.jpg": [
		136,
		11
	],
	"./Suvretta_St_Moritz.jpg": [
		137,
		13
	],
	"./Tschuggen_Arosa.jpg": [
		138,
		14
	],
	"./Unique_Zermatt.jpg": [
		139,
		15
	],
	"./Valsana_Arosa.jpg": [
		140,
		16
	],
	"./Waldhaus_st_Moritz.jpg": [
		141,
		17
	],
	"./Zurbriggen_Saas.jpg": [
		142,
		18
	],
	"./backstage_vernissage_Zermatt.jpg": [
		143,
		19
	],
	"./chasa_montana_Samnaun.jpg": [
		144,
		20
	],
	"./guardaval_Lenzerheid.jpg": [
		145,
		21
	],
	"./jungfrau-wengernalp.jpg": [
		146,
		22
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 85;
module.exports = webpackAsyncContext;